<div class="layout-topbar" [ngClass]="headerClass">


  <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div #topbarmenu class="layout-topbar-menu"
    [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">

    <p-overlayPanel #op [style]="{'position': 'absloute', 'margin': '13px 60px auto', 'width': '320px'}">
      <!-- Replace the ng-template with the following code -->
      <ng-template pTemplate>
        <!-- Overlay panel content -->
        <div style="padding: 6px; display: flex; flex-direction: column; align-items: center;">
          <h2 style="font-size: 1rem; margin-bottom: 10px; text-align: center; position: relative;">
            Are you sure you want to logout?
          </h2>
          <span
            style="display: block; width: 100%; height: 1px; background-color: #264475; margin-bottom: 10px;"></span>
          <div class="flex justify-content-center gap-2">
            <button pButton type="button" label="Yes" class="p-button-success" (click)="logout()">
              <i class="fas fa-check-circle" style="margin-right: 5px;"></i>
            </button>
            <button pButton type="button" label="No" class="p-button-danger" (click)="op.hide()">
              <i class="fas fa-exclamation-circle" style="margin-right: 5px;"></i>
            </button>
          </div>
        </div>
      </ng-template>



    </p-overlayPanel>
    <p-overlayPanel #opSettings [style]="{'position': 'absloute', 'margin': '13px 53px auto', 'width': '550px'}">
      <ng-template pTemplate>
        <div>
          <div class="row">
            <div class="arrow"></div>

            <div *ngIf="settingstatus" class="column dat dtd-box">
              <div class="setings-hdr">
                <i class="layout-menuitem-icon folder"></i>
                <h4>Data Master</h4>

              </div>
              <nav class="navigation">
                <ul class="mainmenu">
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Vessel') === -1"
                      routerLink="pages/settings/vessel/vessel-list">Vessel</a></li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Vessel Class') === -1"
                      routerLink="pages/settings/vessel-class/vesselclass-list">Vessel
                      Class</a></li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Vessel Size') === -1"
                      routerLink="pages/settings/vessels-pooltype/vesselpooltype-list">Vessel Size</a></li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Consumption Category') === -1"
                      routerLink="/pages/settings/consumption-categories/consumption-list">Consumption Category</a>
                  </li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Fuel') === -1"
                      routerLink="/pages/settings/fuel/fuellist">Fuel</a></li>
                      <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Fuels') === -1"
                        routerLink="/pages/settings/fuels/fuellists">Fuel 2.0</a></li>

                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Lube Oil') === -1"
                      routerLink="/pages/settings/lube-oil/lube-oil-list">Lube Oil</a></li>

                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Vessel Group') === -1"
                      routerLink="pages/settings/vessel-group/vesselgroup-list">Vessel
                      Group</a></li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Fuel Category') === -1"
                      routerLink="pages/settings/fuel-category/list">Fuel Category</a></li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Units Of Measure And Threshold') === -1"
                      routerLink="/pages/settings/units-of-measure-and-threshold/units-of-measure-and-threshold">Units
                      Of
                      Measure And Threshold</a></li>
                  <li><a (click)="closeOverlay()" *ngIf="hideModules.indexOf('Event') === -1"
                      routerLink="/pages/settings/event/event-list">Event</a></li>

                  <li *ngIf="hideModules.indexOf('Emission-Kpi') === -1
                    || hideModules.indexOf('Fuel-Kpi') === -1 || hideModules.indexOf('Position-Kpi') === -1">
                    <a>Custom-Kpi
                      <span style='font-size:10px;'>&#9660;</span></a>
                    <ul class="submenu">
                      <li *ngIf="hideModules.indexOf('Emission-Kpi') === -1"><a (click)="closeOverlay()"
                          routerLink="/pages/settings/custom-kpi/emission-kpi">
                          Emission-Kpi</a></li>
                      <li *ngIf="hideModules.indexOf('Fuel-Kpi') === -1"><a (click)="closeOverlay()"
                          routerLink="/pages/settings/custom-kpi/list-fuel-kpi">
                          Fuel-Kpi</a></li>
                      <li *ngIf="hideModules.indexOf('Position-Kpi') === -1"><a (click)="closeOverlay()"
                          routerLink="/pages/settings/custom-kpi/list-position-kpi">
                          Position-Kpi</a></li>
                    </ul>
                  </li>
                  <li *ngIf="hideModules.indexOf('Custom-Vessel') === -1"><a (click)="closeOverlay()"
                      routerLink="/pages/settings/customvessel/custom-vessellist">Custom-Vessel</a></li>
                  <li *ngIf="hideModules.indexOf('NOX-PM-Factors') === -1"><a (click)="closeOverlay()"
                      routerLink="pages/settings/nox-pm-factor/nox-pm-factor-list">NOX-PM-Factors</a></li>
                  <li *ngIf="hideModules.indexOf('Port') === -1"><a (click)="closeOverlay()"
                      routerLink="./pages/settings/port/port-list">Port</a></li>
                  <li *ngIf="hideModules.indexOf('Sea and Shop Trial Data') === -1"><a (click)="closeOverlay()"
                      routerLink="./pages/settings/sea-shopdata/sea-shopdata-list">Sea & Shop Trial Data</a></li>
                  <li *ngIf="hideModules.indexOf('Operator') === -1"><a (click)="closeOverlay()"
                      routerLink="./pages/settings/operator/operator-list">Operator</a></li>
                  <li *ngIf="hideModules.indexOf('DT Model') === -1"><a (click)="closeOverlay()"
                      routerLink="./pages/settings/dt-model/dt-config">DT Model</a></li>
                </ul>
              </nav>
            </div>
            <div class="column">
              <div class="setings-hdr" *ngIf="settingstatus">
                <i class="layout-menuitem-icon warnings-filled"></i>
                <h4>Alerts Settings</h4>

              </div>
              <nav class="navigation" *ngIf="settingstatus && hideModules.indexOf('Standard Alert') === -1">
                <ul class="mainmenu">
                  <li><a (click)="closeOverlay()"
                      routerLink="pages/settings/standard-alerts/standard-alert-list">Standard Alerts</a></li>

                </ul>
              </nav>
              <br>
              <div
                *ngIf=" (usersettingstatus || (hideModules.indexOf('Users') === -1 || hideModules.indexOf('Role') === -1 || hideModules.indexOf('Principals') === -1))"
                class="setings-hdr">
                <i class="layout-menuitem-icon user-settings"></i>
                <h4>User Settings</h4>

              </div>
              <nav
                *ngIf=" (usersettingstatus || (hideModules.indexOf('Users') === -1 || hideModules.indexOf('Role') === -1 || hideModules.indexOf('Principals') === -1))"
                class="navigation">
                <ul class="mainmenu">
                  <li *ngIf="isAdmin && hideModules.indexOf('Users') === -1"><a (click)="closeOverlay()"
                      routerLink="/pages/userSetting/user/user-list">Users</a></li>
                  <li *ngIf="isAdmin && hideModules.indexOf('Role') === -1"><a (click)="closeOverlay()"
                      routerLink="/pages/userSetting/role/list-role">Role</a></li>
                  <li *ngIf="hideModules.indexOf('Principals') === -1"><a (click)="closeOverlay()"
                      routerLink="./pages/settings/principals/principals-list">Principals</a></li>
                </ul>
              </nav>

              <br>
              <div class="setings-hdr" *ngIf=" hideModules.indexOf('Configuration') === -1">
                <i class="sensor"></i>
                <h4>Sensor Module</h4>
              </div>
              <nav class="navigation">
                <ul class="mainmenu">
                  <li *ngIf="hideModules.indexOf('Configuration') === -1">
                    <a (click)="closeOverlay()"
                      routerLink="./pages/settings/sensor-module/configuration/configuration-list">Configuration</a>
                    <!-- Ensure correct router link here -->
                  </li>
                </ul>
              </nav>

              <!-- <div class="setting-img">
                <img src="assets/layout/images/settings_img.jpg" alt="logo" class="app-logo">
              </div> -->
              <div class="abtContnt">
                <h5>ABOUT</h5>
                <p>2023&nbsp;©&nbsp;GeoPerform&nbsp;|&nbsp;Version&nbsp;{{ version }}
                </p>
              </div>

            </div>
          </div>
        </div>
      </ng-template>
    </p-overlayPanel>
    <p-overlayPanel #opPsw>
      <ng-template pTemplate>
        <div>
          <div class="row">

          </div>
        </div>
      </ng-template>
    </p-overlayPanel>


    <!-- <button class="p-link layout-topbar-button">
            <i class="uil uil-border-alt"></i>
            <span>Calendar</span>
        </button>
        <button class="p-link layout-topbar-button">
            <i class="uil uil-bell"></i>
            <span>Profile</span>
        </button> -->
    <div *ngIf="overallstatus" class="navbar">
      <div class="dropdown">
        <button class="dropbtn" pTooltip="Settings" tooltipPosition="bottom">
          <!-- <i class="pi pi-cog" style="font-size: 2rem"></i> -->
          <i class="layout-menuitem-icon ng-tns-c22-12 settings block" (click)="opSettings.toggle($event)"></i>
        </button>

      </div>
    </div>

    <div class="user-details">
      <!-- <img src="{{DefaultAvatarLink}}"/> -->
      <div class="dropdown">
        <button class="dropbtn" pTooltip="Change Password" tooltipPosition="bottom">
          <!-- <i class="pi pi-cog" style="font-size: 2rem"></i> -->
          <i class="layout-menuitem-icon lock" (click)="navigateToChangePassword()"></i>
        </button>


      </div>

    </div>

    <div class="user-details">
      <button class="log-out" pTooltip="Logout" tooltipPosition="bottom">
        <!-- <i class="pi pi-cog" style="font-size: 2rem"></i> -->
        <i class="layout-menuitem-icon logout" (click)="op.toggle($event)"></i>
      </button>
      <!-- <img src="{{DefaultAvatarLink}}"/> -->

    </div>
    <h5 (click)="$event.stopPropagation()" style="display: contents; font-size: 1.15rem;">{{User?.firstName}}
      {{User?.lastName}}</h5>


  </div>
</div>